import { AccountAction } from 'interfaces/AccountAction';
import {
  barChartOutline,
  buildOutline,
  carOutline,
  peopleOutline,
  trendingUpOutline,
} from 'ionicons/icons';

export const navigation = [
  {
    title: 'Work Orders',
    url: '/workorders',
    icon: buildOutline,
    requiredActions: [AccountAction.ListWorkOrders, AccountAction.GetWorkOrder],
  },
  {
    title: 'Equipment',
    url: '/equipment',
    icon: carOutline,
  },
  {
    title: 'Accounts',
    url: '/accounts',
    icon: peopleOutline,
    requiredActions: [AccountAction.ListAccounts, AccountAction.GetAccount],
  },
  {
    title: 'Performance',
    url: '/performance',
    icon: trendingUpOutline,
  },
  {
    title: 'Reports',
    url: '/reports',
    icon: barChartOutline,
  },
];
